import type { Article } from "./types";

export const articles: Article[] = [
  {
    id: "gala-c-seat",
    title: "顶流晚会的C位剧本：排座次的人，早在开播一个月前就写好了名单",
    deck: "一张座次表背后，是番位、档期、对赌与营销号预告的多方角力。我们拿到了一份晚会执行团队内部的'排位逻辑'，还原C位如何被一步步确定。",
    categorySlug: "ent",
    categoryName: "娱乐圈内幕",
    tag: "独家深度",
    tags: ["晚会座次", "资源博弈", "番位", "执行内幕"],
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20empty%20gala%20seating%20hall%20with%20numbered%20chairs%20and%20red%20velvet%20rope%2C%20single%20warm%20spotlight%20from%20above%2C%20cinematic%20editorial%20photography%2C%20crimson%20and%20amber%20tones%2C%20film%20grain%2C%20moody%20dramatic%20atmosphere&width=900&height=600&seq=art-gala-01&orientation=landscape",
    alt: "顶流晚会C位剧本晚会现场红毯座椅与聚光灯",
    readMinutes: 9,
    publishDate: "2026-09-08",
    authorName: "沈砚",
    authorRole: "文娱调查记者",
    authorInitial: "沈",
    featured: true,
    breaking: true,
    rank: 1,
    hotReason: "关于座次的讨论冲上讨论区热度榜首",
    views: "48.2万",
    keywords: ["晚会座次", "C位", "番位", "娱乐圈内幕"],
    sections: [
      {
        heading: "座次表是一份被反复推倒重来的名单",
        paragraphs: [
          "在大多数观众看来，一台晚会的镜头中心是谁，多半是临时安排的结果。但在我们接触到的晚会执行团队内部流程里，情况恰恰相反：一份记载着三十余位嘉宾座次与出场顺序的表格，早在正式录制约四周前就已进入第一版，此后平均要被推翻七到九次。",
          "多次参与大型晚会编排的制片人向我们确认，最终版座次的核心原则从来不是'谁咖位大谁坐中间'，而是一套兼顾赞助商回报、播出平台会员数据与艺人合作续约预期的综合评分。换句话说，聚光灯下的位置，是镜头之外一笔笔账算出来的结果。",
        ],
      },
      {
        heading: "在'改'与'再改'之间，藏着真正的博弈",
        paragraphs: [
          "表格每一次被推翻，往往都对应着一次场外的条件交换。有的艺人团队会用'明年续约''愿意接衍生采访'来换取更靠近中心的位置；也有平台方以'该艺人弹幕互动数据更高'为由，向执行方施压调整出场顺序。",
          "一位长期对接艺人行程的统筹坦言：'我们收到的理由是微笑而体面的，但谁都知道那是在谈筹码。真正坐到C位的人，未必是现场人气最高的人，但一定是最早被写进名单、又最晚被从名单里划掉的人。'",
        ],
      },
      {
        heading: "镜头只拍最体面的十秒，台下是另一种秩序",
        paragraphs: [
          "让外界难以理解的是，许多被粉丝视为'受委屈'的安排，其实是艺人团队主动谈出来的结果——有的艺人宁可让出黄金位，也要换到与某位资方同席，理由是为了接下来两年的项目储备。",
          "当灯光亮起、导播切出那帧体面的全景时，观众看到的是和谐，而亲历过这份名单的人，看到的是一个庞大行业在镜头之外为自己精心计算过的缩影。这不是某一个人的输赢，而是整条产业链运转方式的注脚。",
        ],
      },
    ],
  },
  {
    id: "hot-search-script",
    title: "你所见的'全网热搜'，约有一半是被提前排好的排序剧本",
    deck: "我们梳理了多家平台的议题上架流程，发现所谓'自然发酵'的热搜，相当一部分在登上榜单前就已经被写进了排期表。",
    categorySlug: "net",
    categoryName: "互联网背后",
    tag: "重磅",
    tags: ["热搜排序", "营销排期", "议题运营", "平台逻辑"],
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20smartphone%20screen%20showing%20glowing%20trending%20search%20list%2C%20bokeh%20warm%20city%20lights%20behind%2C%20cinematic%20editorial%20photography%2C%20amber%20and%20deep%20brown%20tones%2C%20film%20grain%2C%20moody%20atmosphere&width=900&height=600&seq=art-hot-01&orientation=landscape",
    alt: "全网热搜排序剧本手机屏幕上滚动的热搜列表",
    readMinutes: 11,
    publishDate: "2026-09-07",
    authorName: "江屿",
    authorRole: "互联网产业观察",
    authorInitial: "江",
    breaking: true,
    rank: 2,
    hotReason: "阅读量在数小时内突破十万",
    views: "39.7万",
    keywords: ["热搜", "排序剧本", "议题运营", "互联网"],
    sections: [
      {
        heading: "一份可以提前七天写好的'上架日历'",
        paragraphs: [
          "在我们的信源仓库里，有一份来自营销代理机构内部的话题上架日历：某品牌的新品发布会、某影视剧的开播预热、某位艺人的澄清时间点，都被清清楚楚地标注在了具体的日期与时段上。",
          "这份日历的特别之处在于，它并非事后整理，而是事前排期——部分所谓'被网友发现的热搜'，其实在正式上线前，就已被决定好要在哪个时段、以什么样的标签组合出现在榜单的哪个位置。",
        ],
      },
      {
        heading: "'自然发酵'与'预定热搜'的边界正在变得模糊",
        paragraphs: [
          "平台一方面声称热搜由真实搜索行为驱动，另一方面又向合作方开放了'运营位'与'资源包'。多位做过投放的从业者告诉我们，两类入口在用户界面上的呈现几乎一致，普通用户根本无从分辨一条话题究竟是'自己火'还是'被安排火'。",
          "一位前平台运营承认：'我们把它们分开统计，但那只是内部口径。对外展示给用户时，我们不会去刻意标注哪一条是买来的——因为那样会让整个页面都显得像广告。'",
        ],
      },
      {
        heading: "当议题成为商品，谁还在乎它是否真实",
        paragraphs: [
          "被排期的话题未必是虚假的——很多事件确实发生了，只是被人为地放大了节奏与热度。真正值得警惕的，是当讨论的发起权被系统性地交给预算而非事实时，公共议题很容易变成一场价格驱动的内容竞赛。",
          "在热搜的流水线上，真实与策划之间只剩一层越来越薄的纸。作为读者，我们能做的，是对'为什么偏偏是它火'保持一点追问，而不是照单全收地相信榜单告诉我们的世界。",
        ],
      },
    ],
  },
  {
    id: "livestream-price-psych",
    title: "直播间那句'破价了'，其实是一场环环相扣的心理局",
    deck: "倒计时、比价图、'仅剩X件'的弹窗，每一种让你心动的设计，背后都有一套来自认知心理学的脚本。",
    categorySlug: "net",
    categoryName: "互联网背后",
    tag: "行业拆解",
    tags: ["直播电商", "破价话术", "冲动消费", "运营脚本"],
    cover:
      "https://readdy.ai/api/search-image?query=live%20streaming%20studio%20with%20ring%20light%20and%20product%20boxes%20and%20flashing%20countdown%20screen%2C%20warm%20amber%20studio%20glow%2C%20cinematic%20editorial%20photography%2C%20film%20grain%2C%20moody%20atmosphere&width=900&height=600&seq=art-live-01&orientation=landscape",
    alt: "直播间破价话术摄影棚环形灯与倒计时大屏",
    readMinutes: 8,
    publishDate: "2026-09-06",
    authorName: "江屿",
    authorRole: "互联网产业观察",
    authorInitial: "江",
    views: "27.5万",
    keywords: ["直播电商", "破价", "话术", "心理脚本"],
    sections: [
      {
        heading: "先让你相信'这价格真的很难得'",
        paragraphs: [
          "多数直播间在下单前的三十秒里，都会完成一次'稀缺性'与'紧迫感'的叠加：右上角随时可能归零的库存条，配合主播不断重复的'这个价格我可能只报一次'。这些设计并非随性发挥，而是被反复测试过的转化工具。",
          "有供应链操盘手向我们透露，所谓'史上最低价'，很多是在开播前就已与品牌方谈好的常态价，'破价'更多是一种话术上的包装，让消费者觉得此刻不下单就会错过。",
        ],
      },
      {
        heading: "比价图与'赠品价值'，用来抵消你的比价冲动",
        paragraphs: [
          "为了阻止你在下单前真的去别处比价，直播间会在画面角落常驻一张'旗舰店价格对比'图，并把一堆赠品换算成'相当于再省XX元'。这套操作的核心，是用一个更容易被理解的价格锚点，替代你原本要去验证的真实价格。",
          "认知心理学家会把它称作'锚定效应'——当先看到虚高的参考价时，后面出现的任何价格都会显得划算。而赠品则进一步模糊了你对'主商品到底值多少钱'的判断。",
        ],
      },
      {
        heading: "如何做一名没那么容易'上头'的观众",
        paragraphs: [
          "了解脚本的目的，不是让你从此抵触直播，而是让你在下单前多留两秒：先关掉声音比一次价，把赠品价值打个折，再问自己一句——如果没有倒计时，我还会买吗。",
          "真正划算的交易，不会因为多犹豫三十秒就消失。把冲动留给真诚的折扣，把理性留给自己，才是这场心理局里唯一的稳赢策略。",
        ],
      },
    ],
  },
  {
    id: "on-set-ledger",
    title: "剧组里的隐形账本：盒饭、片酬与代拍的三角账",
    deck: "在镜头拍不到的地方，一份戏的预算被分成肉眼可见的'大头'与无人清点的'零头'。我们跟访了三个剧组，看见钱在缝隙里流动的样子。",
    categorySlug: "ent",
    categoryName: "娱乐圈内幕",
    tag: "一线手记",
    tags: ["剧组预算", "片酬", "代拍经济", "行业成本"],
    cover:
      "https://readdy.ai/api/search-image?query=movie%20set%20backstage%20with%20clutter%20of%20lighting%20equipment%20cables%20and%20craft%20service%20lunch%20boxes%2C%20warm%20practical%20lights%2C%20cinematic%20documentary%20photography%2C%20film%20grain%2C%20moody%20natural%20atmosphere&width=900&height=600&seq=art-ledger-01&orientation=landscape",
    alt: "剧组隐形账本片场灯光线材与散落的盒饭",
    readMinutes: 10,
    publishDate: "2026-09-05",
    authorName: "沈砚",
    authorRole: "文娱调查记者",
    authorInitial: "沈",
    rank: 4,
    hotReason: "评论区大量剧组从业者现身说法",
    views: "22.1万",
    keywords: ["剧组", "片酬", "代拍", "制作成本"],
    sections: [
      {
        heading: "账目上的钱，和流到账目外的钱",
        paragraphs: [
          "一部戏的预算表看起来井井有条：演员片酬、服化道、后期、宣发各有定额。但当镜头真正开拍，我们发现真正的成本并不总按表格流动——有的环节被反复追加，有的环节则被默契地'压缩'到看不见的地方。",
          "一位做了十余年的制片助理告诉我们，预算表之外的'隐形账'，往往集中在两类地方：一是临时加戏带来的设备与人员加班费，二是一些灰色渠道的开支，它们通常不进正式的财务流水，却真实地推高了整部戏的成本。",
        ],
      },
      {
        heading: "代拍不是剧组的对立面，而是一门共生生意",
        paragraphs: [
          "不少剧组对代拍既恨又离不开：恨他们偷拍影响保密，却又离不开他们制造的路透热度。一位宣传统筹坦承，部分低成本项目甚至会默认代拍的存在，用'不经意泄露'的片场照片为开播造势。",
          "在这种共生关系里，代拍者深谙供需：哪部戏的演员自带流量，他们的'机位费'就越高。一支拍摄热门主角的代拍队伍，一晚的收入可能超过普通剧组里一名灯光助理整月的薪水——这也是为什么即便频频被驱赶，他们依然愿意围在警戒线外。",
        ],
      },
      {
        heading: "当预算的裂缝开始反噬创作",
        paragraphs: [
          "隐形账最危险的地方，在于它最终会反噬到作品本身。当资金被层层消耗在镜头之外，留给美术置景与特效的预算就被悄然压缩，观众看到的'质感下降'，源头往往不是创作能力，而是账单上一处无人深究的裂缝。",
          "一部戏台前的风光，从来都是台后无数笔账目精打细算后的结果。那些被省下的、被挪用的、被绕开的钱，最终都会以某种形式，出现在最终的作品里。",
        ],
      },
    ],
  },
  {
    id: "franchise-trap",
    title: "加盟招商的'稳赚不赔'话术，为何总能精准击中你",
    deck: "从开场即'排队交钱'的气氛，到模板化的回本模型，我们拆解了连锁加盟招商会背后一套成熟的成交脚本。",
    categorySlug: "cap",
    categoryName: "商业资本",
    tag: "风险提示",
    tags: ["加盟招商", "回本模型", "投资陷阱", "商业调查"],
    cover:
      "https://readdy.ai/api/search-image?query=crowded%20business%20franchise%20expo%20stage%20with%20spotlight%20and%20smiling%20host%20holding%20microphone%2C%20brand%20posters%20behind%2C%20warm%20conference%20lighting%2C%20cinematic%20editorial%20photography%2C%20amber%20tones%2C%20film%20grain%2C%20moody%20atmosphere&width=900&height=600&seq=art-franchise-01&orientation=landscape",
    alt: "加盟招商稳赚不赔话术招商会舞台与高举话筒的主讲人",
    readMinutes: 9,
    publishDate: "2026-09-04",
    authorName: "陆衡",
    authorRole: "财经调查记者",
    authorInitial: "陆",
    rank: 3,
    hotReason: "被大量意向加盟者转发收藏",
    views: "31.3万",
    keywords: ["加盟招商", "回本", "投资", "商业资本"],
    sections: [
      {
        heading: "第一步，先把你拖进'不加盟就亏'的氛围",
        paragraphs: [
          "真正的成交，往往在招商会开场的第一小时就已完成一半。灯光、激昂的配乐、滚动播放的转账记录，加上主持人反复强调'这个区域只剩最后一个名额'，一切都为了营造一种群体性的紧迫：再不行动，机会就被别人抢走了。",
          "在心理学里这被称为'稀缺与从众'的组合拳。当现场许多人举手示意已交定金时，原本还在犹豫的你，很容易把'他们交了我没交'误判成'我错过了好事'。",
        ],
      },
      {
        heading: "那张'回本模型'，其实隐藏了三个假设",
        paragraphs: [
          "绝大多数加盟商拿到的回本测算表，都建立在三个不言自明的假设上：客流量能达到总部所在直营店的水平、店铺能维持表上的翻台或复购率、以及总部承诺的供应链价格在未来不调整。",
          "财经调查中我们发现，这三项恰恰是最不可控的部分。当商圈人流被竞争分流、当统一采购价在两年后悄然上浮，那张漂亮的回本曲线，很快就变成了一笔笔只见投入不见产出的流水。",
        ],
      },
      {
        heading: "判断一份招商邀请，先问清这三个问题",
        paragraphs: [
          "面对任何'稳赚'的承诺，我们建议你先问三个问题：这个品牌的直营店真实盈利数据从哪来、在我不熟悉的城市是否有人加盟成功、以及总部的核心利润来自加盟费还是门店经营。",
          "答案往往能替你拨开话术的迷雾：一个真正靠经营赚钱的体系，不怕你多问几句；而一个只想赚加盟费的生意，最怕的正是你冷静下来的那三十秒。",
        ],
      },
    ],
  },
  {
    id: "phone-gimmick",
    title: "发布会台前的新款'黑科技'，与实验室里的真实进度隔了多远",
    deck: "当镜头前的演示反复'恰好成功'，产品叙事与工程现实之间，往往隔着一段被剪辑掉的等待与回退。",
    categorySlug: "tech",
    categoryName: "科技幕后",
    tag: "技术观察",
    tags: ["发布会", "产品演示", "技术落差", "工程现实"],
    cover:
      "https://readdy.ai/api/search-image?query=large%20dim%20keynote%20stage%20with%20single%20product%20silhouette%20and%20giant%20screen%20showing%20abstract%20circuit%2C%20warm%20spotlight%20beams%2C%20cinematic%20tech%20editorial%20photography%2C%20amber%20and%20ink%20tones%2C%20film%20grain%2C%20moody%20atmosphere&width=900&height=600&seq=art-phone-01&orientation=landscape",
    alt: "发布会黑科技演讲舞台上的产品剪影与电路大屏",
    readMinutes: 8,
    publishDate: "2026-09-03",
    authorName: "柯岩",
    authorRole: "科技深度撰稿",
    authorInitial: "柯",
    views: "18.6万",
    keywords: ["发布会", "黑科技", "产品", "工程落差"],
    sections: [
      {
        heading: "演示成功的背后，是彩排了无数次的'确定性'",
        paragraphs: [
          "在一场新品发布会上，最让工程团队紧张的时刻，往往不是技术讲解，而是那一段看似随手即兴的功能演示。因为演示一旦失败，损失的不只是几分钟，而是整场发布会的叙事节奏。",
          "多位参与过大型发布会筹备的工程师向我们证实，许多演示其实经过了反复彩排，甚至准备了'备用方案'与'静默兜底'——镜头前一次顺滑的成功，背后可能是几十次失败尝试后的精心筛选。",
        ],
      },
      {
        heading: "宣传的'首发'，与量产时的'后续推送'",
        paragraphs: [
          "更值得留意的落差发生在发布会与真机之间。一些台前以'行业首发'姿态亮相的功能，到了用户实际拿到的设备上，往往被表述为'将通过后续版本陆续推送'。",
          "这类措辞的灵活空间，恰恰是产品叙事与工程进度之间的缓冲带：它既保住了营销时点的声量，又为技术尚未完全成熟的模块争取了打磨时间。对厂商而言这是理性选择，但对消费者来说，需要分清'现在就有'与'以后会有'是两回事。",
        ],
      },
      {
        heading: "给新品祛魅的三个步骤",
        paragraphs: [
          "面对一款'参数拉满'的新机，我们建议你暂时放下发布会的情绪，做三件事：去查该功能是否存在于首发固件、去看看第一批真实用户而非媒体的上手反馈、以及把它宣传中最激动人心的那项，放到日常使用里推演一遍。",
          "发布会负责把技术的远方讲给你听，而真实使用才会告诉你它到底走到了哪一步。两者之间那段被剪掉的距离，恰恰是判断一款产品值不值得为它买单的标尺。",
        ],
      },
    ],
  },
  {
    id: "vc-valuation",
    title: "估值翻倍的融资背后，尽调清单里被悄悄隐去的三行",
    deck: "当媒体通稿用'估值翻倍'定义一家公司的成功，鲜有人追问：这份让数字飞升的底稿里，有哪些条目从未被正面回答。",
    categorySlug: "cap",
    categoryName: "商业资本",
    tag: "独家深度",
    tags: ["融资估值", "尽调", "财务造假风险", "商业资本"],
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20hands%20signing%20a%20stack%20of%20financing%20documents%20under%20warm%20desk%20lamp%2C%20calculator%20and%20pen%2C%20cinematic%20corporate%20editorial%20photography%2C%20amber%20tones%2C%20film%20grain%2C%20serious%20moody%20atmosphere&width=900&height=600&seq=art-vc-01&orientation=landscape",
    alt: "融资估值幕后暖灯下签署文件与计算器的手",
    readMinutes: 9,
    publishDate: "2026-09-02",
    authorName: "陆衡",
    authorRole: "财经调查记者",
    authorInitial: "陆",
    rank: 5,
    hotReason: "被多位创投从业者私下转发",
    views: "20.4万",
    keywords: ["融资", "估值", "尽调", "创投"],
    sections: [
      {
        heading: "通稿里的'翻倍'，与账面上的'口径'",
        paragraphs: [
          "资本市场对'估值翻倍'的叙事总是乐此不疲，但在投融资尽调行业内部，大家更关心的是数字背后的统计口径：营收是确认了现金流还是只确认了合同、客户是买断了还是订阅、增长是自然发生还是靠补贴买来。",
          "一位曾参与多家明星项目尽调的财务顾问告诉我们，许多看似亮眼的增长，只要把口径稍作调整，立刻会现出原形——这也是为什么同一家公司，在不同机构的估值模型里能相差数倍。",
        ],
      },
      {
        heading: "那些没有被正面回答的清单条目",
        paragraphs: [
          "标准的尽调清单通常长达数百行，但真正暴露问题的地方，往往是表格上那几行'留待后续提供'的空白。当一家公司对某项收入的构成、某笔关联交易的定价、某个大客户的真实性始终闪烁其词，投资人需要的高度警惕就应当被拉满。",
          "在我们的调查中，相当比例的暴雷案例，都曾在早期尽调里留下过类似没有闭合的缺口。它们起初只是三行未填的空白，却在随后的融资轮次里被一次次以'时间紧张'为由跳过，最终演变成难以收拾的风险。",
        ],
      },
      {
        heading: "别只盯着估值，更要看现金流的'体温'",
        paragraphs: [
          "对普通关注者而言，与其被一轮轮融资通稿牵引情绪，不如学会看更朴素的指标：经营性现金流是否为正、应收账款是否在膨胀、创始团队是否在频繁套现。",
          "估值衡量的是资本愿意为想象支付的价格，而现金流才是一家公司真实体温的读数。当前者脱离后者太远，崩断的那一天，往往是通稿里最安静的。",
        ],
      },
    ],
  },
  {
    id: "property-fee",
    title: "物业费上涨的前夜，业主群里那场措辞克制的暗战",
    deck: "一张拟调价公告发出前后，业主、业委会与物业三方在群里展开的，是一场关于知情权、代表权与信任的微妙博弈。",
    categorySlug: "mso",
    categoryName: "民生观察",
    tag: "民生纪实",
    tags: ["物业费", "业委会", "业主权益", "社区治理"],
    cover:
      "https://readdy.ai/api/search-image?query=community%20owners%20meeting%20room%20with%20long%20table%2C%20notices%20and%20documents%20and%20muted%20warm%20lighting%2C%20cinematic%20slice%20of%20life%20editorial%20photography%2C%20warm%20sand%20tones%2C%20film%20grain%2C%20moody%20atmosphere&width=900&height=600&seq=art-prop-01&orientation=landscape",
    alt: "物业费上涨前夜业委会会议桌上的公告与文件",
    readMinutes: 7,
    publishDate: "2026-08-30",
    authorName: "许青梧",
    authorRole: "民生观察记者",
    authorInitial: "许",
    views: "15.8万",
    keywords: ["物业费", "业委会", "业主", "社区"],
    sections: [
      {
        heading: "一张公告，往往在正式发出前就已'走漏'",
        paragraphs: [
          "在很多小区，关于物业费拟调价的消息，很少以官方公告为起点。它更常以一张被拍照传阅的'内部会议纪要'、一句'听保洁阿姨说'的传言，率先在业主群里扩散开来。",
          "这种信息真空造成的直接后果，是业主们不得不在传言与辟谣之间自行判断，而对物业和业委会的不信任，往往就从这种'为什么不先告诉我们'的错位里开始累积。",
        ],
      },
      {
        heading: "业主群里的话语权，并不等于投票的票数",
        paragraphs: [
          "在调价表决的博弈中，一个常被误解的事实是：群里最活跃的那批声音，未必代表绝大多数业主。真正的计票依据，是书面或线上的实名表决，而多数沉默的业主，恰恰是决定成败的关键票仓。",
          "正因如此，我们观察到，博弈双方都在争抢同一批人——物业希望争取到'服务确实该升级'的认同，而持反对意见的业主则试图唤醒更多'平时不关注'的邻居，把一次被悄然推进的表决，变成一场被充分讨论的公共事务。",
        ],
      },
      {
        heading: "一场健康的调价，应当先回答三个问题",
        paragraphs: [
          "面对物业费上涨，业主真正需要的不是一句'成本涨了'，而是三个可以被核实的答案：涨上去的钱具体流向哪些服务、过去三年的收支明细为何不能透明公开、以及若服务不达预期，是否设有可操作的退出与考核机制。",
          "当一场调价能同时回答这三问，它才从'单方面通知'变成'共同决策'。信任从来不是靠公告堆出来的，而是靠每一次账目透明、每一次承诺兑现，慢慢攒回来的。",
        ],
      },
    ],
  },
  {
    id: "secondhand-clothes",
    title: "旧衣回收箱里的生意经：善意的链条，为何会悄悄变味",
    deck: "你投进箱子的每一件旧衣，都会沿着一条你并不清楚的分拣、出口与去向的链条流动。我们追踪了它的真实终点。",
    categorySlug: "mso",
    categoryName: "民生观察",
    tag: "调查",
    tags: ["旧衣回收", "慈善", "分拣链条", "资源再生"],
    cover:
      "https://readdy.ai/api/search-image?query=warehouse%20of%20sorted%20second%20hand%20clothes%20in%20bales%20under%20warm%20skylight%2C%20workers%20sorting%20folded%20textiles%2C%20cinematic%20documentary%20photography%2C%20warm%20beige%20tones%2C%20film%20grain%2C%20moody%20atmosphere&width=900&height=600&seq=art-cloth-01&orientation=landscape",
    alt: "旧衣回收生意经分拣仓库里成捆的二手衣物",
    readMinutes: 8,
    publishDate: "2026-08-28",
    authorName: "许青梧",
    authorRole: "民生观察记者",
    authorInitial: "许",
    views: "12.4万",
    keywords: ["旧衣回收", "捐赠", "分拣", "循环利用"],
    sections: [
      {
        heading: "公益的外衣下，是一整套精细的商业分拣",
        paragraphs: [
          "当你把旧衣投进贴着'爱心捐赠'标语的回收箱，很少有人知道它并不会直接送到受助者手中。绝大多数旧衣会先被送往分拣仓库，按新旧程度、材质与可穿性被分为数档。",
          "在这套分拣体系里，真正达到'可捐赠'标准的衣物占比往往不高，而更多的旧衣会流向出口贸易、再生纤维加工甚至填充材料——它们共同构成了一个远比'献爱心'复杂的产业。",
        ],
      },
      {
        heading: "善意的标识，能否被商业动机'顺手借用'",
        paragraphs: [
          "问题的关键不在于旧衣是否会被商业利用——循环经济本身无可厚非，而在于回收箱上的公益标识是否在误导投放者的初衷。当箱体印着捐赠口号、实际却主要服务商业出口时，善意的认知与实际去向之间就出现了裂缝。",
          "我们的调查发现，部分回收运营方为了降低成本，会在'纯公益'与'纯商业'之间模糊表述，既拿公益形象换取小区进驻的便利，又靠商业分拣赚取利润，两头的好处都占，而透明披露却严重不足。",
        ],
      },
      {
        heading: "让善意流向它该去的地方",
        paragraphs: [
          "要让旧衣回收保持善意，需要的是透明而不是道德指责。投放者在捐赠前，可以多留意箱体是否公示了运营主体、分拣去向与公益用途说明；有关部门也应当对'公益标识'的使用建立更严格的规范。",
          "回收本身是一件好事，值得被保留。我们要拆穿的，从来不是这件好事，而是那些借善意的名义、却在暗处悄悄稀释它的人。",
        ],
      },
    ],
  },
  {
    id: "night-convenience",
    title: "深夜便利店外的'临时占位'：一座城市的秩序博弈",
    deck: "凌晨两点，便利店门口那块空地，是代驾司机的休息站、外卖骑手的换电站，也是城管巡逻单上反复出现的模糊地带。",
    categorySlug: "urb",
    categoryName: "都市异闻",
    tag: "城市切片",
    tags: ["便利店", "占位", "代驾", "城市秩序"],
    cover:
      "https://readdy.ai/api/search-image?query=quiet%20warm%20lit%20convenience%20store%20doorway%20at%20night%20with%20a%20few%20parked%20electric%20scooters%20and%20a%20resting%20delivery%20rider%20silhouette%2C%20cinematic%20urban%20editorial%20photography%2C%20amber%20glow%20and%20dark%20blue%20night%2C%20film%20grain%2C%20moody%20atmosphere&width=900&height=600&seq=art-night-01&orientation=landscape",
    alt: "深夜便利店临时占位暖光门口与停放的代步车",
    readMinutes: 6,
    publishDate: "2026-08-26",
    authorName: "温野",
    authorRole: "都市观察专栏",
    authorInitial: "温",
    views: "9.7万",
    keywords: ["便利店", "代驾", "占位", "都市秩序"],
    sections: [
      {
        heading: "一块空地，三种截然不同的深夜用途",
        paragraphs: [
          "对整座城市而言，便利店门口那块不过二十平方米的空地，在白天几乎无人留意。但一过午夜，它会被三类人轮流使用：等待接单的代驾司机把这里当作临时调度点，下夜班的外卖骑手在这里更换电池，偶尔还有跑长途的网约车司机靠边小憩。",
          "空地的价值在凌晨被无限放大——它是这座城市为数不多同时拥有灯光、卫生间与平价热水的公共角落。没有人规定这块地属于谁，但几乎每个人都默认它'该被这样用'。",
        ],
      },
      {
        heading: "当便利与秩序在巡逻单上相遇",
        paragraphs: [
          "麻烦随之而来。占位的电动车会挡住行人通道，聚集的人群有时会被投诉噪音，而城管在凌晨的巡逻，也因此多了一项'提醒疏散'的工作。",
          "一位片区执法人员坦言，这类处理大多是劝离而非处罚，因为他们清楚：这些人不是在捣乱，而是在讨生活。真正棘手的是，当管理规范与真实需求错位时，执法很容易陷入'按章办伤害人情，讲人情又失了章法'的两难。",
        ],
      },
      {
        heading: "一座城市的温情，常藏在对'临时'的默许里",
        paragraphs: [
          "有意思的是，这片模糊地带最终往往靠一种朴素的默契维持着平衡：店家睁一只眼闭一只眼，因为这群深夜的常客也会顺手买走一杯热咖啡；司机们则自觉让出主通道，不把'方便'变成'打扰'。",
          "城市里的很多秩序，并不来自冷冰冰的规则，而来自无数个深夜里彼此体谅的瞬间。那片被默许的'临时占位'，正是这种脆弱的、却真实存在的城市温情。",
        ],
      },
    ],
  },
  {
    id: "city-parking-game",
    title: "写字楼停车位争夺战：一位难求背后，藏着排位与心照不宣",
    deck: "在早晚高峰的写字楼地库里，车位的归属并不只看先来后到，还掺杂着公司层级、物业偏好与一句句'先帮我占着'的江湖规矩。",
    categorySlug: "urb",
    categoryName: "都市异闻",
    tag: "观察",
    tags: ["写字楼", "停车位", "通勤", "都市规则"],
    cover:
      "https://readdy.ai/api/search-image?query=dim%20underground%20office%20parking%20garage%20rows%20of%20empty%20spaces%20with%20warm%20amber%20ceiling%20lights%2C%20one%20car%20turning%20corner%2C%20cinematic%20urban%20editorial%20photography%2C%20film%20grain%2C%20moody%20atmosphere&width=900&height=600&seq=art-park-01&orientation=landscape",
    alt: "写字楼停车位争夺战昏暗地库中的空车位与车灯",
    readMinutes: 6,
    publishDate: "2026-08-24",
    authorName: "温野",
    authorRole: "都市观察专栏",
    authorInitial: "温",
    views: "8.3万",
    keywords: ["写字楼", "停车", "通勤", "物业"],
    sections: [
      {
        heading: "早高峰的地库，是一门排位社会学",
        paragraphs: [
          "如果你在八点半的写字楼地库里多待一会，会发现车流的调度远比想象中精细：高层管理者的固定车位靠电梯口最近，中层则被安排在动线顺畅的转角，而普通员工的车往往要绕着层层立柱，停进最远的角落。",
          "这套看似默认的格局，极少被白纸黑字公示，却以'地库惯例'的方式被所有人默契接受。它无声地提醒着每一位车主：在职场，空间的位置往往与位置的空间相互对应。",
        ],
      },
      {
        heading: "'先帮我占着'背后的江湖规矩",
        paragraphs: [
          "在固定车位永远不够用的楼宇里，还流行着另一套心照不宣的规则。有人会提前把车停在某个空位旁的车头位置，用'我在等你挪'的姿态替同事占位；也有人与地库保安保持着一种微妙的默契，靠一句客气的招呼换取清晨优先引导。",
          "这些潜规则让'一位难求'的焦虑有了喘息的空间，也织成了一张人情网。但它的另一面是：初来乍到、毫无门路的新员工，往往要在地库里多绕十几分钟，才能听懂这座楼真正的话语体系。",
        ],
      },
      {
        heading: "当车位焦虑被写进一天的情绪曲线",
        paragraphs: [
          "别小看每天地库里的十几分钟。对很多通勤者而言，能否顺利停到一个不太远的位置，直接影响着走进办公室前十分钟的心情。一次绕着立柱的漫长寻找，足以让一天的节奏从'从容'滑向'紧绷'。",
          "城市通勤的体感，从来不只由里程决定，也由这些不起眼的环节拼凑而成。写字楼地库里的每一次让行与争夺，都是都市快节奏生活最微小、也最真实的表情。",
        ],
      },
    ],
  },
  {
    id: "variety-edit-cut",
    title: "综艺后期剪辑的'上帝之手'：一个动作如何被切成三种情绪",
    deck: "同一段素材，在正片、预告与花絮里能讲出三个完全不同的故事。我们走进后期机房，看叙事如何在剪刀下被重新塑造。",
    categorySlug: "ent",
    categoryName: "娱乐圈内幕",
    tag: "幕后工艺",
    tags: ["综艺剪辑", "后期", "叙事", "真人秀"],
    cover:
      "https://readdy.ai/api/search-image?query=dark%20video%20editing%20suite%20with%20multiple%20timeline%20monitors%20and%20an%20editor%20hands%20on%20keyboard%2C%20warm%20screen%20glow%2C%20cinematic%20editorial%20photography%2C%20amber%20and%20deep%20brown%20tones%2C%20film%20grain%2C%20moody%20atmosphere&width=900&height=600&seq=art-edit-01&orientation=landscape",
    alt: "综艺剪辑后期机房多屏时间线与编辑的双手",
    readMinutes: 7,
    publishDate: "2026-08-22",
    authorName: "沈砚",
    authorRole: "文娱调查记者",
    authorInitial: "沈",
    views: "14.1万",
    keywords: ["综艺剪辑", "后期", "真人秀", "叙事"],
    sections: [
      {
        heading: "真人秀的'真'，是在素材堆里被挑出来的",
        paragraphs: [
          "一档真人秀动辄拍摄数百小时的素材，但一期正片往往只有不到九十分钟。从海量素材到成片的过程，本质是一场关于'谁的故事值得被讲'的选择——而做出选择的，是后剪机房里那些盯着时间线的剪辑师。",
          "许多观众以为真人秀呈现的就是嘉宾的真实全貌，但参与过后期的人都知道，那只是无数条叙事线中被选中并放大的一条。同一个尴尬的表情，放在冲突段落里是'针锋相对'，放在和解段落里又成了'口是心非的可爱'。",
        ],
      },
      {
        heading: "预告片的'上帝之手'，最能体现叙事的可塑性",
        paragraphs: [
          "最能体现剪辑塑造力的是预告片：它可以把一句普通回应剪成剑拔弩张的对立，也可以把一段平淡互动拼成温馨的高光。素材本身没有变，变的只是被选取的瞬间与排列的顺序。",
          "这种'以预告拉期待'的手法本身是中性的营销手段，但当它开始影响观众对嘉宾真实为人处世的判断时，就需要一个清醒的认知：镜头前的一切，从来都是多重滤镜叠加的结果，而非未经修饰的现场。",
        ],
      },
      {
        heading: "在'塑造'与'失真'之间，后期需要一条底线",
        paragraphs: [
          "优秀的后期是在尊重事实的前提下讲好故事，而失格的后期则是为了冲突与流量，通过断章取义改变事件的性质。两者之间的分界，往往取决于节目组是否愿意保留'被剪辑掉的上下文'。",
          "对观众而言，与其追问'这是不是真的'，不如学会把真人秀当成一种'被精心编排过的真实'来欣赏——享受它的戏剧性，同时记得：那把剪刀的落点，从来不是一个中立的决定。",
        ],
      },
    ],
  },
];

export const getArticle = (id: string): Article | undefined =>
  articles.find((a) => a.id === id);

export const byCategory = (slug: string): Article[] =>
  articles.filter((a) => a.categorySlug === slug);

export const featuredArticles = articles.filter((a) => a.featured);

export const breakingList = articles.filter((a) => a.breaking);

export const hotArticles = articles
  .filter((a) => a.rank)
  .sort((a, b) => (a.rank ?? 99) - (b.rank ?? 99));